<template>
  <div class="home">
    <div class="banner">
      <img
        id="bannerImg"
        class="img1"
        src="../assets/banner3.jpg"
        alt=""
      >
      <img
        class="img2"
        src="../assets/bg-m@2x.png"
        alt=""
      >
      <div
        class="box_fixed"
        id="boxFixed"
        :class="{'is_fixed' : isFixed}"
      >
        <div class="tab">
          <div
            class="df1"
            @click="goSearch"
          >
            <img
              class="search"
              src="../assets/search1@2x.png"
              alt=""
            >
          </div>
          <span class="separate">|</span>
          <div
            class="df1 li tab-li"
            :class="seTab === 1 ? 'active' : ''"
            @click="switchTab(1)"
          >装修风格</div>
          <span class="separate">|</span>
          <div
            class="df1 tab-li"
            :class="seTab === 2 ? 'active' : ''"
            @click="switchTab(2)"
          >厨房类型</div>
          <span class="separate">|</span>
          <div
            class="df1 tab-li"
            :class="seTab === 3 ? 'active' : ''"
            @click="switchTab(3)"
          >产品型号</div>
        </div>
        <!--  v-if="seTab !=3" -->
        <div
          class="label"
          v-if="labelArr.length > 0"
        >
          <span
            class="li"
            :class="seLabelIndex.findIndex((item2) => item2 === item.id) === -1 ? '' : 'lable-se'"
            v-for="(item,index) in labelArr"
            :key="index"
            @click="seLabel(index,item.id)"
          >{{item.name}}</span>
        </div>
        <!-- <div
          class="label tx-l"
          v-else
        >
          <span class="li2">共{{conArr.length}}款</span>
        </div> -->
      </div>
      <div class="content">
        <div
          class="content-top"
          v-if="seTab != 3"
        >
          <div
            class="content-top-li"
            v-if="(index+1) % 3 != 0"
            v-for="(item,index) in conArr"
            :key="index"
            @click="goDetail(item)"
          >
            <img
              :src="item.coverUrl"
              alt=""
            >
            <div class="title">{{item.title.slice(0,10)}}</div>
            <div class="tips sug_info4">
              <span
                class="mr10"
                v-for="(item2,index2) in item.keywords"
                :key="index2"
              >·{{item2}}</span>
            </div>
          </div>
          <div
            class="content-top-li2"
            v-else
            @click="goDetail(item)"
          >
            <img
              :src="item.coverUrl"
              alt=""
            >
            <div class="title">{{item.title.slice(0,20)}}</div>
            <div class="tips sug_info">
              <span
                class="mr10"
                v-for="(item2,index2) in item.keywords"
                :key="index2"
              >·{{item2}}</span>
            </div>
          </div>
        </div>
        <div
          class="content-top"
          v-else
        >
          <div
            class="content-top-li"
            v-for="(item,index) in conArr"
            :key="index"
            @click="goDetail(item)"
          >
            <img
              :src="item.coverUrl"
              alt=""
            >
            <div class="title">{{item.title.slice(0,10)}}</div>
            <div class="tips sug_info4">
              <span
                class="mr10"
                v-for="(item2,index2) in item.keywords"
                :key="index2"
              >·{{item2}}</span>
            </div>
          </div>

        </div>
        <!-- <div class="none">没有更多了</div> -->
        <img
        v-if="pageNum != lastPageNum"
          class="none-icon"
          src="../assets/noMore.png"
          alt=""
        >
      </div>
    </div>
    <div
      class="lz-box"
      @click="goInfo"
    >
      <img
        src="../assets/dingzhi@2x.png"
        alt=""
      >
    </div>
    <!-- loading -->
     <!-- <van-loading
        type="spinner"
        color="#9D1D22"
        size="44"
        v-if="showLoading"
        style="z-index:2"
      /> -->
    <van-overlay :show="loadshow">
      <div class="wrapper" @click.stop>
       
        <van-loading size="50px" vertical color="#9D1D22"></van-loading>
      </div>
    </van-overlay>
    
  </div>
</template>

<script>
import storage from "@/common/storage";
import utils from "@/common/utils";
import wx from "weixin-js-sdk";
const scrollToTop = () => {
  let scrollTop = document.documentElement.scrollTo || document.body.scrollTop;
  if (scrollTop > 0) {
    window.requestAnimationFrame(scrollTop);
    window.scrollTop(0, scrollTop - scrollTo / 8);
  }
};
export default {
  name: "Home",
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f0f0f0");
    next();
  },
  data() {
    return {
      loadshow:false,
      showLoading: false,
      seLabelIndex: [], //选中的label
      index: "", //选择的
      labelArr: [],
      conArr: [],
      isFixed: false,
      offsetTop: 0,
      seTab: 1,
      pageNum: 1, //当前页数
      pageSize: 20,
      totalNum: 1, //总页数
      lastPageNum: 1,
    };
  },
  created() {
    let that = this;
    that.getContentList();
    document.title = "方太厨房百景图";
    setTimeout(()=>{
      wx.miniProgram.postMessage({ data: {foo: 'bar'} })
    },1000)

  },
  mounted() {
    let that = this;

    window.addEventListener("scroll", that.initHeight);
    that.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      that.offsetTop = document.querySelector("#boxFixed").offsetTop;
      that.banneroffsetTop = document.querySelector(".banner").offsetTop;
    });
    that.selectPropertyParameterByPropertyId();
     // share
    that.$api.article
      .querySign({
        type: 1,
      })
      .then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的js接口列表
        });
        wx.ready(function() {
          console.log('xxxx')
         
          wx.updateAppMessageShareData({
            title: "方太厨房百景图", // 分享标题
            desc: '炊烟起处，幸福厨房', // 分享描述 summary
            link: `${location.href.split("#")[0]}#/`,
            imgUrl:"https://hsimage.fotile.com/17df2c11-7d24-43da-8071-af561643f366.jpg?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            success: function() {
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: "方太厨房百景图", // 分享标题
            desc: '炊烟起处，幸福厨房', // 分享描述 summary
            link: `${location.href.split("#")[0]}#/`,
            imgUrl:"https://hsimage.fotile.com/17df2c11-7d24-43da-8071-af561643f366.jpg?x-oss-process=image/resize,m_fixed,h_200,w_200,limit_0", // 分享图标
            success: function() {
              // 设置成功
            },
          });
          
        });
      })
  },
  methods: {
    
    // 获取分类
    selectPropertyParameterByPropertyId() {
      let that = this;
      let cid = "";
      if (that.seTab === 1) {
        cid = 9;
      } else if (that.seTab === 2) {
        cid = 7;
      } else if (that.seTab === 3) {
        switch (location.href.split("#")[0]) {
          case "https://hsapp.fotile.com/kitchenTools_h5/"://生产
            cid = 21;
            break;
          case "https://hsstg.fotile.com/kitchenTools_h5/"://预生产
            cid = 21;
            break;
          case "https://hstest.fotile.com/kitchenTools_h5/"://测试
            cid = 21;
            break;
          case "https://hscom.efotile.com/kitchenTools_h5/"://开发
            cid = 29;
            break;
          default:
            cid = 21;
        }
      }
      that.$api.article
        .selectPropertyParameterByPropertyId({
          id: cid,
        })
        .then((res) => {
          that.labelArr = res.data.data;
        })
        .catch((err) => {})
        .finally((all) => {});
    },
    // 获取列表
    getContentList() {
      let that = this;
      let cid = "";
      if (that.seTab === 1) {
        cid = 9;
      } else if (that.seTab === 2) {
        cid = 7;
      } else if (that.seTab === 3) {
        switch (location.href.split("#")[0]) {
          case "https://hsapp.fotile.com/kitchenTools_h5/"://生产
            cid = 21;
            break;
          case "https://hsstg.fotile.com/kitchenTools_h5/"://预生产
            cid = 21;
            break;
          case "https://hstest.fotile.com/kitchenTools_h5/"://测试
            cid = 21;
            break;
          case "https://hscom.efotile.com/kitchenTools_h5/"://开发
            cid = 29;
            break;
          default:
            cid = 21;
        }
      }
      that.loadshow = true;
      return new Promise(function(resolve, reject) {
        that.$api.article
          .getContentList({
            keyword: "",
            classPropertyId: cid,
            propertyId: that.seLabelIndex.join(","),
            pageIndex: that.pageNum,
            pageSize: that.pageSize,
          })
          .then((res) => {
            // if (res.data.data.list) {
            //   res.data.data.list.forEach((item) => {
            //     item.title = item.title.slice(0,10);
            //   });
            // }
            // if (res.data.data.list) {
            //   res.data.data.list.forEach((element) => {
            //     element.summary = element.summary.split(" ");
            //     // console.log("item", element.summary);
            //   });
            // }
            if (that.pageNum === 1) {
              that.conArr = res.data.data.list;
              that.pageNum = res.data.data.pageNum; //获取当前页数
              that.totalNum = res.data.data.pages; //获取总页数
            } else {
              that.conArr = [...that.conArr, ...res.data.data.list];
            }
            ++that.pageNum;
            // that.showLoading = false;
            resolve(res.data.data);
          })
          .catch((err) => {
            // that.showLoading = false;
            that.lastPageNum = that.lastPageNum - 1;
            reject();
            console.log("获取列表err", err);
          }).finally((all) => {
            that.loadshow = false;
          });
      });
    },
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false;

      // 是否滚动到底部
      var scrollTop2 =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeitht =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop2 + windowHeitht >= scrollHeight - 50) {
        if (this.pageNum > this.totalNum) {
          return;
        } else {
          if (this.pageNum != this.lastPageNum) {
            this.lastPageNum = this.pageNum; //更新lastPageNum
            this.getContentList();
          }
        }
      }
    },
    goDetail(e) {
      let isInsideMiniProgram=0;
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          isInsideMiniProgram=1
        } else {
          isInsideMiniProgram=0
        }
      })
      this.$router.push({
        path: "/detailLink",
        query: { 
          shareId: e.id,
          timeNum: new Date().getTime() ,
          isInsideMiniProgram 
        },
        
      });
    },
    seLabel(index, nid) {
      let result = this.seLabelIndex.findIndex((item2) => item2 === nid);
      result === -1
        ? this.seLabelIndex.push(nid)
        : this.seLabelIndex.splice(
            this.seLabelIndex.findIndex((item) => item === nid),
            1
          );
      this.pageNum = 1;
      this.getContentList();
      // 设置滚动条高度
      if (this.getScrollTop() > document.getElementById("bannerImg").offsetHeight) {
        window.scrollTo(0, document.getElementById("bannerImg").offsetHeight-100);
      }
    },
    switchTab(index) {
      this.seTab = index;
      // if (index != 3) {
        this.selectPropertyParameterByPropertyId();
      // }
      this.pageNum = 1;
      this.seLabelIndex = [];
      this.getContentList();
      // 设置滚动条高度
      if (this.getScrollTop() > document.getElementById("bannerImg").offsetHeight) {
        window.scrollTo(0, document.getElementById("bannerImg").offsetHeight-100);
      }
    },
    goInfo(e) {
      let that = this;
      that.$router.push({
        path: "/info",
        query: { timeNum: new Date().getTime() },
      });
    },
    goSearch() {
      let that = this;
      that.$router.push({
        path: "/search",
        query: { timeNum: new Date().getTime() },
      });
    },
    // 获取滚动条高度
    getScrollTop() {
      var scrollPos;
      if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
      } else if (document.compatMode && document.compatMode != "BackCompat") {
        scrollPos = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollPos = document.body.scrollTop;
      }
      return scrollPos;
    },
  },
  //回调中移除监听
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};

</script>
<style scoped>
.van-overlay{
  z-index: 9;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.none-icon {
  width: 155px;
  height: 15px;
  margin: 20px auto;
}
.box_fixed {
  position: absolute;
  width: 100%;
  top: 320px;
  /* left: 50%;
  transform: translate(-50%);
  margin: 0 auto; */
  line-height: 40px;
  z-index: 2;
  box-sizing: border-box;
  padding: 0 10px;
}
.is_fixed {
  position: fixed !important;
  top: 0 !important;
  z-index: 999 !important;
  background-color: #000;
}
.banner {
  width: 100%;
  height: 410px;
  position: relative;
}
.banner .img1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.banner .img2 {
  width: 100%;
  height: 154px;
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.4;
}
.fbox {
  position: absolute;
  width: 95%;
  left: 50%;
  top: 320px;
  transform: translate(-50%);
}
.tab {
  display: flex;
  align-items: center;
  font-size: 16px;
  height: 40px;
  line-height: 16px;
  width: 100%;
  margin-bottom: 12px;
  /* position: absolute; */
  /* bottom: 80px;
  left: 50%;
  transform: translate(-50%); */
  color: #fff;
}
.tab .separate {
  color: #cccccc;
  opacity: 0.5;
}
.tab .tab-li {
  opacity: 0.5;
}
.tab .active {
  position: relative !important;
  color: #fff !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
.tab .active:before {
  content: "";
  width: 30px;
  height: 4px;
  background-color: #9d1d22;
  border-radius: 8px;
  transform: translate(-50%);
  left: 50%;
  bottom: -10px;
  position: absolute;
}
.tab .search {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.label {
  /* display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow-y: scroll; */
  overflow-x: auto;
  white-space: nowrap;
  background-color: #f0f0f0;
  /* height: 37px; */
  height: auto;
  margin: 0 auto;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  /* padding-bottom: 10px; */
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  /* padding-bottom: 20px; */
  /* padding: 0 20px;
  box-sizing: border-box; */
}
.label .lable-se {
  border: 1px solid #bd252a !important;
  height: 20px;
  line-height: 20px;
  padding: 0px 12px;
  font-size: 12px;
  color: #9d1d22 !important;
  background-color: #ffcccc !important;
  border-radius: 10px;
  margin-right: 5px;
}
.label .li {
  border: 1px solid #9a9a9a;
  height: 20px;
  line-height: 20px;
  padding: 2px 12px;
  font-size: 12px;
  color: #666666;
  background-color: #ffffff;
  border-radius: 10px;
  margin-right: 4px;
}
.label .li2 {
  height: 20px;
  line-height: 20px;
  padding: 2px 12px;
  font-size: 12px;
  color: #666666;
  background-color: #ffffff;
  border-radius: 4px;
}

.content {
  position: absolute;
  top: 418px;
  width: 100%;
}
.content-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* flex-direction: column; */
  padding: 10px 20px 0 20px;
  background-color: #f0f0f0;
  /* height: 100vh;
  overflow-y: scroll; */
}

.content-top-li {
  width: 47.6%;
  /* flex: 1; */
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: 12px;
  overflow: hidden;
}
.content-top-li2 {
  width: 100%;
  /* flex: 1; */
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: 12px;
  overflow: hidden;
}
.content-top-li img {
  width: 100%;
  height: 141px;
}
.content-top-li2 img {
  width: 100%;
  height: 156px;
}
.content-top-li .title,
.content-top-li2 .title {
  color: #000;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
  white-space: nowrap;
  word-wrap:normal;
  /* word-wrap:break-word; */
  overflow: hidden;
  width: 90%;
  /* text-overflow:clip; */
  /* margin-top: 10px; */
  margin: 10px auto 0 auto;
}
.content-top-li .tips,
.content-top-li2 .tips {
  color: #999999;
  font-size: 9px;
  width: 84%;
  margin: 11px auto 15px auto;
}
.content-top-li .tips span {
  line-height: 12px;
}
.lz-box img {
  width: 56px;
  height: 56px;
  position: fixed;
  bottom: 16px;
  right: 16px;
}
</style>
